module.exports = __webpack_public_path__ + "img/prioritas_vippack_cod_dg.f1e7c4f6.png";